/** Shopify CDN: Minification failed

Line 18:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 29:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 31:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 33:6 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 34:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 34:4 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 35:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 35:67 Transforming destructuring to the configured target environment ("es5") is not supported yet
... and 152 more hidden warnings

**/
import Dinero from "https://cdn.jsdelivr.net/npm/dinero.js@1.9.1/build/esm/dinero.min.js";

window.theme = window.theme || {};

const settings = {
  selectors: {
    data: "ProductJSON",
    dataNew: "MetafieldsJSON",
    container: "ProductBundleSection",
    price: "[data-product-price]",
    afterpay: "BundleAfterpay",
    select: "BundleVariants",
    button: "[data-add-to-cart]",
  },
};

const container = document.getElementById(settings.selectors.container);
const priceWrapper = document.querySelector(settings.selectors.price);
const variantWrapper = document.getElementById(settings.selectors.select);

const { enabledCurrencies } = theme.settings ?? [];
let { active: activeCurrency, rate } = window.Shopify
  ? window.Shopify.currency
  : null;
const activeCurrencyObj = activeCurrency
  ? enabledCurrencies.find(({ ISO }) => ISO === activeCurrency)
  : null;
const currencySymbol = activeCurrencyObj ? activeCurrencyObj.symbol : "$";
const dineroFormat = "$0,0.00";

let productJSON, variantJSON, metafieldsJSON;
let allProducts = [],
  multipleSelectionCounter = [];

function formatPriceWithDollarSign(price) {
  const formattedPrice = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(price);

  return formattedPrice;
}

const renderVariantLayout = (type, arr, object, optional = []) => {
  const layout = container.dataset.variantStyle;
  let isAddon = type === "addon";
  let isPreorder = $("#ProductBundleSection").data("pre-order");

  if (type === "selection") {
    multipleSelectionCounter.push({
      [object.title]: {
        currentCount: 0,
        maxCount: object.barcode ? Number(object.barcode) : 1,
        details: object,
      },
    });
  }

  switch (layout) {
    case "images": {
      const div = document.createElement("DIV");
      div.classList.add("variant-images-wrapper", type);

      let priority_display = $("#ProductBundleSection").data(
        "priority-display"
      );
      if (priority_display !== "none" && priority_display === object.title) {
        div.classList.add("variant-images-wrapper--priority");
      }

      const ul = document.createElement("UL");
      ul.classList.add("variant-images");

      let hasItemSelected = false;
      for (let [index, item] of arr.entries()) {
        const li = document.createElement("LI");
        li.classList.add("variant-image");

        let variant = isAddon ? item.node.variants.edges[0].node : null;
        let id = variant ? variant.id : item.node.id;
        let qty = isAddon
          ? item.node.totalInventory
          : item.node.quantityAvailable;
        let image = isAddon
          ? item.node.variants.edges[0].node.image?.url
          : item.node.image?.url;

        if (isAddon) {
          li.classList.add("addon-item");
        } else {
          li.style.backgroundImage = `url(${image})`;
        }

        if (isAddon) {
          const filteredItem = item.node.variants.edges.filter(
            (edge) => edge.node.title.toLowerCase() === "addon"
          )[0];
          li.dataset.price = filteredItem.node.price.amount;
          li.dataset.id = theme.GraphQL.retrieveID(filteredItem.node.id);
        } else {
          li.dataset.id = theme.GraphQL.retrieveID(id);
          li.dataset.price = item.node.price.amount;
        }
        li.dataset.quantityAvailable = qty;
        li.dataset.item = "accent-text";
        li.dataset.availableForSale = item.node.availableForSale;

        if (item.node.availableForSale) {
          li.dataset.arkhiPdpOptionvariant = "";
        }
        li.setAttribute("title", item.node.title);

        if (isAddon) {
          li.innerHTML = `<div class="js-enabled mb3">
              <div id="gift-box-container" style="margin:7px 0px;">
                <input type="checkbox" id="giftBoxField" class="gift-option-checkbox option-selector" value="Small - Gift Box">
                <label for="giftBoxField">
                  <img src="https://cdn.shopify.com/s/files/1/0644/7238/3733/files/New_gift_box_image.jpg?v=1730962189">
                </label>
              </div></div>`;
        } else {
          li.innerHTML = `<span class="small-hidden">${item.node.title}<br/>${
            item.node?.price?.amount ? "($" + item.node.price.amount + ")" : ""
          }</span>`;
        }

        console.log("Item>>", item);
        // if(isAddon){
        //   const tags = item.node.tags;
        //   for (let tag of tags) {
        //     if (tag.indexOf('bundle_price_') != -1) li.dataset.price = tag.replace('bundle_price_', '');
        //     if (tag.indexOf('dropdown_label_') != -1) li.innerHTML = `<span class="visually-hidden">${tag.replace('dropdown_label_', '')}</span>`;
        //   }
        // }

        if (!item.node.availableForSale && !isPreorder) {
          li.setAttribute("disabled", true);
          $(".klaviyo-bis-trigger")
            .addClass("bis-shown")
            .removeClass("bis-hidden");
          console.log("Showing BIS trigger");
        }

        // if (
        //   productJSON.title
        //     .toLowerCase()
        //     .indexOf(item.node.title.toLowerCase()) !== -1 &&
        //   !isAddon
        // )
        if (
          item.node?.barcode &&
          item.node?.barcode?.toLowerCase() === "selected" &&
          !isAddon
        ) {
          allowMultipleSelection(li, type, object, optional);
          updateBundlePrice(li, type, object);

          hasItemSelected = true;
        }

        if (isAddon) {
          li.querySelector(".gift-option-checkbox").addEventListener(
            "click",
            () => {
              // ul.querySelectorAll('li').forEach(item => item.removeAttribute('selected'));
              if (li.hasAttribute("selected")) {
                removeFromData(li, type);
                li.removeAttribute("selected");
                updateBundlePrice(li, type, object);
              } else {
                selectedToData(li, type);
                li.setAttribute("selected", "");
                updateBundlePrice(li, type, object);
              }
            },
            false
          );
        } else {
          li.addEventListener(
            "click",
            () => {
              allowMultipleSelection(li, type, object, optional);
              updateBundlePrice(li, type, object);
            },
            false
          );
        }
        ul.appendChild(li);
      }

      // This code is to select first item by default

      // if (!hasItemSelected && type === 'selection') {
      //   let selectedItem = ul.firstElementChild;
      //   allowMultipleSelection(selectedItem, type, object, optional);
      //   updateBundlePrice(selectedItem, type, object);
      // }

      // This code is to select unselect first item so everything setelled down properly
      if (!isAddon && ul.firstElementChild) {
        let selectedItem = ul.firstElementChild;
        selectedItem.click();
        setTimeout(() => {
          selectedItem.click();
        }, 300);
      }

      let plusPrice = 0;
      if (arr && arr?.length) {
        plusPrice = arr[0]?.node?.price?.amount;
      }

      const banner = document.createElement('img');
      banner.src = "https://cdn.shopify.com/s/files/1/0644/7238/3733/files/Lumios_Typewriter_Used_470_x_350_px.png?v=1711022639";
      banner.classList.add('bundle-variant-img')

      const title = document.createElement("label");
      title.classList.add("bundle-variant-label");
      title.dataset.item = "accent-text";
      title.innerHTML =  isAddon
        ? "Gift Box"
        : `${
            object.barcode && object.barcode > 1
              ? `Select up to ${object.barcode} charm(s)`
              : "Select up to 1 charm(s)"
          }`;
      // title.innerHTML =
      //   plusPrice > 0
      //     ? title.innerHTML + 
      //       `<br/>Add an additional Charm to your piece ( Each Charm is $25 )`
      //     : title.innerHTML;
      // if(!isAddon) div.appendChild(banner);
      div.appendChild(title);
      div.appendChild(ul);
      variantWrapper.appendChild(div);
      break;
    }
    default: {
      const details = document.createElement("DETAILS");
      const summary = document.createElement("SUMMARY");
      summary.dataset.item = "accent-text";

      const contents = document.createElement("DIV");
      contents.classList.add("variant-contents");

      details.appendChild(summary);
      details.appendChild(contents);
      document.addEventListener("click", function (evt) {
        if (evt.target.closest(".product-form--variants")) return;
        details.removeAttribute("open");
      });

      let default_selected = false;
      const ul = document.createElement("UL");
      for (let [index, item] of arr.entries()) {
        const li = document.createElement("LI");
        const tags = item.node.tags;

        let variant = isAddon ? item.node.variants.edges[0].node : null;
        let id = variant ? variant.id : item.node.id;
        let qty = isAddon
          ? item.node.totalInventory
          : item.node.quantityAvailable;

        li.dataset.id = theme.GraphQL.retrieveID(id);
        if (item.node.variants) {
          li.dataset.price = item.node.variants.edges[0].node.price.amount;
        } else {
          li.dataset.price = item.node.price.amount;
        }

        li.dataset.quantityAvailable = qty;
        li.textContent = item.node.title;
        li.dataset.item = "accent-text";
        li.dataset.availableForSale = item.node.availableForSale;
        li.dataset.arkhiPdpVariantinput = "";

        if (isAddon) {
          for (let tag of tags) {
            if (tag.indexOf("bundle_price_") != -1)
              li.dataset.price = tag.replace("bundle_price_", "");
            if (tag.indexOf("dropdown_label_") != -1)
              li.textContent = tag.replace("dropdown_label_", "");
          }
        }

        if (!item.node.availableForSale) {
          li.setAttribute("disabled", true);
        }

        if (!default_selected && item.node.availableForSale) {
          li.setAttribute("selected", "");

          // Update data
          selectedToData(li, type); // Initialise data on first list item

          if (isAddon) {
            updateBundlePrice(li, type, object);
          }

          // Update summary text and dataset
          summary.textContent = item.node.title;
          summary.dataset.selected = theme.GraphQL.retrieveID(id);

          default_selected = true;
        }

        // Event handler
        li.addEventListener(
          "click",
          () => {
            // Update data
            selectedToData(li, type);

            updateBundlePrice(li, type, object);

            // Update summary text and dataset
            summary.textContent = li.textContent;
            summary.dataset.selected = li.dataset.id;

            // Close summary
            summary.click();
          },
          false
        );

        ul.appendChild(li);
      }
      contents.appendChild(ul);

      const title = document.createElement("P");
      title.classList.add("bundle-variant-label");
      title.dataset.item = "accent-text";
      title.textContent = object.title;

      const container = document.createElement("DIV");
      container.classList.add("bundle-variant", type);

      container.appendChild(title);
      container.appendChild(details);

      variantWrapper.appendChild(container);
      break;
    }
  }
};

function initData() {
  const dataElement = document.getElementById(settings.selectors.data);
  if (!dataElement) return;
  productJSON = JSON.parse(dataElement.innerText);
  variantJSON = productJSON.variants;
  if (variantJSON < 2) return;
  variantJSON.shift();
}

function renderElements() {
  // Selection
  const selectionFiltered = variantJSON.filter((item) =>
    item.sku?.startsWith("selection_")
  );
  const selectionPromises = selectionFiltered.map(async (item) => {
    const query = theme.GraphQL.getQuery(item, "title", "selection_");
    return await theme.GraphQL.sendRequest(query, "product-bundle");
  });

  for (let [index, promise] of selectionPromises.entries()) {
    promise.then(async (x) => {
      let data = await x.data.products;
      if (data.edges.length === 0) return;

      let selection = selectionFiltered[index];
      let title = selection.sku.replace("selection_", "");
      let product = data.edges.find(
        (edge) => edge.node.title.toLowerCase() === title.toLowerCase()
      );
      let variants = product?.node.variants.edges;

      if (!variants) return;
      renderVariantLayout("selection", variants, selection, product);
    });
  }

  // Variants
  const variantFiltered = variantJSON.filter((item) =>
    item.sku?.startsWith("variant_")
  );
  const variantPromises = variantFiltered.map(async (item) => {
    const query = theme.GraphQL.getQuery(item, "title", "variant_");
    return await theme.GraphQL.sendRequest(query, "product-bundle");
  });
  for (let [index, promise] of variantPromises.entries()) {
    promise.then((x) => {
      const {
        data: {
          products: { edges },
        },
      } = x;
      if (edges.length === 0) return;
      const product_title = variantFiltered[index].sku.replace("variant_", "");
      const variant_title = variantFiltered[index].title;
      const product = edges.find(
        ({ node: { title } }) => title === product_title
      );
      if (!product) return;

      for (let item of product.node.variants.edges) {
        if (
          item.node.title === variant_title ||
          item.node.title === "Default Title"
        ) {
          const obj = {
            id: theme.GraphQL.retrieveID(item.node.id),
            type: "variant",
            title: item.node.title,
            price: JSON.parse(item.node.price.amount),
            quantityAvailable: item.node.quantityAvailable,
            availableForSale: item.node.availableForSale,
          };
          allProducts.push(obj);
        }
      }
    });
  }

  // Addons
  const addonFiltered = variantJSON.filter((item) =>
    item.sku?.startsWith("addon_")
  );
  const addonPromises = addonFiltered.map(async (item) => {
    const query = theme.GraphQL.getQuery(item, "tag", "addon_");
    return await theme.GraphQL.sendRequest(query, "product-bundle");
  });

  for (let [index, promise] of addonPromises.entries()) {
    promise.then((x) => {
      if (x.data.products.edges.length === 0) return;
      const products = x.data.products.edges;
      let addon = addonFiltered[index];
      renderVariantLayout("addon", products, addon);
    });
  }

  // Update afterpay price
  const bundlePrice = document.querySelector(settings.selectors.price);
  const afterpayPrice = document.getElementById(settings.selectors.afterpay);
  const observerConfig = { attributes: false, childList: true, subtree: false };
  const observerCallback = (mutationsList, observer) => {
    const { target } = mutationsList.find(({ type }) => type === "childList");
    if (!target) {
      observer.disconnect();
      return;
    }

    const { dineroAmount } = target.dataset;
    const money = Dinero({
      amount: +dineroAmount,
      currency: activeCurrencyObj.ISO,
    }).divide(4);

    afterpayPrice.textContent = money.toFormat(dineroFormat);
  };
  const observer = new MutationObserver(observerCallback);
  if (afterpayPrice) observer.observe(bundlePrice, observerConfig);
}

function showErrorMsg(field) {
  const errorMsg = $(field).siblings(".error-msg");
  errorMsg.text("This field is required.");
  $("html, body").animate(
    {
      scrollTop: errorMsg.offset().top - 100,
    },
    600
  );
}

function initAddToCartEvents() {
  const addToCartButton = document.querySelector(settings.selectors.button);
  let unavailable = allProducts.forEach((x) => !x.availableForSale);
  let isPreorder = $("#ProductBundleSection").data("pre-order");
  let preOrderMessage = $("#ProductBundleSection").data("pre-order-message");

  const updateCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const parent = e.target.parentNode;
    let randomGeneratedID = Math.floor(Math.random() * 1000000 + 1),
      items_data = [];

    // addToCartButton.classList.add('is-loading');
    // addToCartButton.setAttribute('disabled','disabled');

    const parentObj = {
      quantity: 1,
      // id: +container.dataset.parentBundleId,
      id: +window.theme.selectedVariant.id,
      properties: {
        _bundlePriceCurrency: activeCurrencyObj.ISO,
        _bundleDineroAmount: $("#BundlePrice").attr("data-dinero-amount"),
        _bundlePrice: $("#BundlePrice").text(),
        _bundleItemType: "parent",
        _bundleSize: allProducts.length + 1,
        _bundleUniqueID: randomGeneratedID,
      },
    };
    // First Validate the From
    const form = addToCartButton.closest("form");
    //console.log("is this form", form);
    if (form) {
      if (form.checkValidity()) {
        //console.log("Form is valid");
      } else {
        form.reportValidity();
        //console.log("Form is not valid");
      }
    }
    const birthstoneFields = document.querySelectorAll(
      'input[name^="properties[_birthstone-"]', // Starts with properties[birthstone-]
      'input[name*="birthstone"]' // Contains birthstone anywhere in the name
    );
    const moonFields = document.querySelectorAll(
      'input[name^="properties[_moon-"]', // Starts with properties[birthstone-]
      'input[name*="moon"]' // Contains birthstone anywhere in the name
    );
    const elementFields = document.querySelectorAll(
      'input[name^="properties[_Element"]'
    );
    if (birthstoneFields) {
      for (const field of birthstoneFields) {
        if (!field.value.trim()) {
          console.error(`Field "${field.name}" is empty!`);
          showErrorMsg(field);
          return;
        } else {
          console.error(`Success`);
          $(field).siblings(".error-msg").text("");
        }
      }
    }
    if (moonFields) {
      for (const field of moonFields) {
        try {
          let defaultValue = null;
          if (field.value.trim() === "") {
            showErrorMsg(field);
            return;
          }
          try {
            defaultValue = JSON.parse(field.value)?.color;
          } catch (error) {
            console.error(
              `Error parsing JSON value for field "${field.name}":`,
              error
            );
            continue;
          }
          if (defaultValue && defaultValue.toLowerCase().includes("purple")) {
            console.log(
              `Field "${field.name}" (value: "${defaultValue}") contains color "Purple". Selecting...`
            );
            showErrorMsg(field);
            return;
          } else {
            console.log(`Field "${field.name}" (value: "${defaultValue}")`);
            $(field).siblings(".error-msg").text("");
          }
        } catch (error) {
          console.error(`Error processing field "${field.name}":`, error);
        }
      }
    }

    if (elementFields) {
      for (const field of elementFields) {
        if (!field.value.trim()) {
          console.error(`Field "${field.name}" is empty!`);
          showErrorMsg(field);
          return;
        } else {
          $(field).siblings(".error-msg").text("");
        }
      }
    }

    //Add Form Properties
    const allProperties = addToCartButton
      .closest("form")
      .querySelectorAll("input[name*='properties']");
    for (const property of allProperties) {
      parentObj.properties[property.name.replace(/(^.*\[|\].*$)/g, "")] =
        property.value;
    }

    if (isPreorder) {
      if (preOrderMessage == "none") {
        parentObj.properties["preorder"] = "true";
      } else {
        parentObj.properties["preorder"] = preOrderMessage;
      }
    }
    items_data.push(parentObj);

    for (let product of allProducts) {
      const childObj = {
        quantity: 1,
        id: +product.id,
        properties: {
          _bundleItemType: `${
            product.type === "addon"
              ? "child_addon"
              : product.type === "selection"
              ? "child_select"
              : "child"
          }`,
          _bundleUniqueID: randomGeneratedID,
          _bundleItemPrice: product.price.toFixed(2),
          _bundleNoDiscount: product.noDiscount,
        },
      };
      items_data.push(childObj);
    }

    const addingToCart = async () => {
      const config = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items_data }),
      };
      let response = await fetch("/cart/add.js", config);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    };

    if (typeof Shopify === "undefined") {
      window.Shopify = {};
    }
    if (typeof Shopify.getCart === "undefined") {
      Shopify.getCart = function (callback, cart) {
        if (!cart) {
          return jQuery.getJSON("/cart.js", function (cart, textStatus, xhr) {
            if (typeof callback === "function") {
              callback(cart, textStatus, xhr);
            } else {
              Shopify.onCartUpdate(cart);
            }
          });
        } else {
          if (typeof callback === "function") {
            callback(cart);
          } else if (typeof Shopify.onCartUpdate === "function") {
            Shopify.onCartUpdate(cart);
          }
        }
      };
    }

    addingToCart()
      .then((response) => {
        window.cart.getCart();
        window.cart.openCartDropdown();
        Shopify.getCart(
          function (cart) {
            parent.dataset.loading = false;

            // window.theme.partials.Cart.updateAllHtml(function () { })
            // window.theme.partials.Cart.updateTotals()
            // const cartDrawer = document.querySelector('.header--cart-link')
            // if (cartDrawer) cartDrawer.click()
          }.bind(this)
        );
      })
      .catch((error) => console.log("Error:", error));
  };

  (async () => {
    const isPreorder = $("#ProductBundleSection").data("pre-order");
    await new Promise((resolve, reject) => {
      setTimeout(() => {
        unavailable = allProducts.some((x) => !x.availableForSale);
        resolve();
      }, 1000); // resolve
    });

    if (isPreorder) {
      addToCartButton.removeAttribute("disabled");
      addToCartButton.classList.remove("loading");
      addToCartButton.addEventListener("click", updateCart, false);
      console.log("Some products unavailable, but is a pre-order", isPreorder);
      return;
    }

    if (unavailable) {
      console.log("Some products unavailable", unavailable);
      addToCartButton.setAttribute("disabled", true);
      $(".klaviyo-bis-trigger").addClass("bis-shown").removeClass("bis-hidden");
      console.log("Showing BIS trigger");
      return;
    }

    // Remove disabled attr, loading class, update text and allow click event handle
    // addToCartButton.classList.remove('is-loading');
    // addToCartButton.removeAttribute('disabled');
    addToCartButton.addEventListener("click", updateCart, false);
  })();
}

window.theme.updatePrice = function () {
  let { originalPrice, currentPrice } = priceWrapper.dataset;

  let money = Dinero({
    amount: +currentPrice,
    currency: activeCurrencyObj.ISO,
  });
  // const conversionFee = 1.015; // As per Shopify https://help.shopify.com/en/manual/markets/pricing/exchange-rates#manual-exchange-rate-conversions
  const conversionFee = 1.0;

  for (const { type, price } of allProducts) {
    if (type === "variant" || price === 0) continue;
    const convert =
      activeCurrencyObj.ISO !== "AUD"
        ? Math.round(+price * +rate * conversionFee)
        : +price;
    const value = Dinero({
      amount: convert,
      currency: activeCurrencyObj.ISO,
      precision: 0,
    });
    money = money.add(value);
  }

  priceWrapper.textContent = `${money.toFormat(dineroFormat)}`;
  priceWrapper.dataset.dineroAmount = money.getAmount();
};

function updateBundlePrice(elem, type, object) {
  const scriptContainer = document.getElementById(settings.selectors.data);
  const qtyAvailable = elem ? parseInt(elem.dataset.quantityAvailable) : 0;
  const productTemplate = scriptContainer.dataset.productTemplate ?? "";
  const addToCartButton = document.querySelector(settings.selectors.button);
  const isPreorder = $("#ProductBundleSection").data("pre-order");

  let { originalPrice, currentPrice } = priceWrapper.dataset;

  let money = Dinero({
    amount: +currentPrice,
    currency: activeCurrencyObj.ISO,
  });
  // const conversionFee = 1.015; // As per Shopify https://help.shopify.com/en/manual/markets/pricing/exchange-rates#manual-exchange-rate-conversions
  const conversionFee = 1.0;

  if (productTemplate === "bundles") {
    if (type !== "selection") {
      let price = elem ? (elem.dataset.price ? elem.dataset.price : 0) : 0;
      const convert =
        activeCurrencyObj.ISO !== "AUD"
          ? Math.round(+price * +rate * conversionFee)
          : +price;
      const value = Dinero({
        amount: convert,
        currency: activeCurrencyObj.ISO,
        precision: 0,
      });
      money = money.add(value);
    }
  } else {
    for (const { type, price } of allProducts) {
      if (type === "variant" || price === 0) continue;
      const convert =
        activeCurrencyObj.ISO !== "AUD"
          ? Math.round(+price * +rate * conversionFee)
          : +price;
      const value = Dinero({
        amount: convert,
        currency: activeCurrencyObj.ISO,
        precision: 0,
      });
      money = money.add(value);
    }
  }

  priceWrapper.textContent = `${money.toFormat(dineroFormat)}`;
  priceWrapper.dataset.dineroAmount = money.getAmount();

  const title = elem ? elem.title.toLowerCase() : "None";
  if (qtyAvailable <= 0 && title !== "chain only" && title !== "None") {
    addToCartButton.setAttribute("disabled", "true");
  } else if (
    allProducts.some(
      ({ availableForSale, quantityAvailable, title }) =>
        !availableForSale && quantityAvailable === 0 && title !== "chain only"
    )
  ) {
    addToCartButton.setAttribute("disabled", "true");
  } else {
    $(".klaviyo-bis-trigger").removeClass("bis-shown").addClass("bis-hidden");
    console.log("Hiding BIS trigger");
    addToCartButton.removeAttribute("disabled");
  }
  if (isPreorder) {
    $(".klaviyo-bis-trigger").addClass("bis-shown").removeClass("bis-hidden");
    console.log("Showing BIS trigger");
    addToCartButton.removeAttribute("disabled");
  }
}

// Changes main product image with selected item
// Performs a search to determine if the selected item's title is included to the product thumbnail's image src
// Uses theme's built-in "updateVariantMedia" function to change the image
function updateProductMedia(item) {
  const title = item.title
    .replaceAll(" ", "")
    .replaceAll(":", "-")
    .replaceAll("é", "e");
  const productThumbs = document.querySelectorAll("[data-thumbnail]");

  for (let thumbnail of productThumbs) {
    let image = thumbnail.querySelector("img");
    let srcset = image.srcset ? image.srcset : image.src;

    if (srcset.includes(title)) {
      const newImagePos = thumbnail.dataset.thumbIndex;
      const slider = document.querySelector("[data-product-slideshow]");

      if (slider && slider.classList.contains("flickity-enabled")) {
        themeVendor.FlickityFade.data(slider).select(newImagePos);
      }

      break;
    }
  }
}

function allowMultipleSelection(item, type, object, optional) {
  const noDiscountTag = optional
    ? optional.node?.tags?.some((tag) => tag.includes("_bundle_no_discount"))
    : false;
  console.log("Item", item, "Object", object, "type", type);
  const obj = {
    id: item.dataset.id,
    type: type,
    title: item.textContent,
    price:
      type === "selection" && noDiscountTag
        ? JSON.parse(item.dataset.price)
        : JSON.parse(object.price / 100),
    quantityAvailable: parseInt(item.dataset.quantityAvailable),
    availableForSale: optional.node?.availableForSale ?? false,
    noDiscount: noDiscountTag,
  };

  const found = allProducts.some(
    (product) => JSON.parse(product.id) === JSON.parse(item.dataset.id)
  );
  let selection = multipleSelectionCounter.find((obj) => object.title in obj);
  let maxCount = selection[object.title].maxCount;

  if (found) {
    // This line is restricting to atleast one selection of items.
    // if (selection[object.title].currentCount <= 1) return;
    selection[object.title].currentCount =
      selection[object.title].currentCount !== 0
        ? selection[object.title].currentCount - 1
        : 0;

    allProducts = allProducts.filter(
      (product) => JSON.parse(product.id) !== JSON.parse(item.dataset.id)
    );
    item.toggleAttribute("selected");
  } else {
    if (maxCount === 1) {
      let parent = item.parentNode;
      let prevSelected = parent?.querySelector(".variant-image[selected]");
      if (prevSelected) prevSelected.removeAttribute("selected");

      const found = allProducts.some((product) => product.type === type);
      if (found) {
        allProducts.forEach((product) => {
          if (product.type === type) {
            product.id = item.dataset.id;
            product.title = item.textContent;
            product.price =
              type === "selection" && noDiscountTag
                ? JSON.parse(item.dataset.price)
                : JSON.parse(object.price / 100);
            product.quantityAvailable = parseInt(
              item.dataset.quantityAvailable
            );
            product.noDiscount = noDiscountTag;
          }
        });
      } else allProducts.push(obj);

      item.toggleAttribute("selected");
    } else {
      if (
        selection[object.title].currentCount < selection[object.title].maxCount
      ) {
        selection[object.title].currentCount += 1;
        allProducts.push(obj);
        item.toggleAttribute("selected");
      } else console.error("Limit for multiple selection reached.");
    }
  }

  // Update product main image with selected item
  updateProductMedia(obj);
}

function removeFromData(item, type) {
  const found = allProducts.some((product) => product.type === type);
  if (found) {
    allProducts = allProducts.filter((product) => product.type !== type);
  }
}

function selectedToData(item, type) {
  console.log("Item", item, "Type", type);
  const obj = {
    id: item.dataset.id,
    type: type,
    title: item.textContent,
    price: JSON.parse(item.dataset.price),
    quantityAvailable: parseInt(item.dataset.quantityAvailable),
    availableForSale: item.dataset.availableForSale,
  };

  const found = allProducts.some((product) => product.type === type);

  if (found) {
    allProducts.forEach((product) => {
      if (product.type === type) {
        product.id = item.dataset.id;
        product.title = item.textContent;
        product.price = JSON.parse(item.dataset.price);
        (product.quantityAvailable = parseInt(item.dataset.quantityAvailable)),
          (product.availableForSale = item.dataset.availableForSale);
      }
    });
  } else allProducts.push(obj);

  // Update product main image with selected item
  updateProductMedia(obj);
}

function init() {
  if (!container) return;
  console.log("Starting product bundle...");
  initData();
  //if not has selection return
  // const selectionFiltered = variantJSON.filter((item) =>
  //   item.sku?.startsWith("selection_")
  // );

  // if(selectionFiltered.length < 1) return;
  renderElements();
  initAddToCartEvents();
}

init();

window.updateBundlePrice = updateBundlePrice;
